import './index.scss';

import React, {useEffect, useId, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import {
	getProfileMultiSelectLabel,
	isProfileSelectedInSelection,
	toggleProfileInSelection,
	VIRTUAL_ALL_PROFILE_ID
} from '../../profileSelection';

const ProfileMultiSelect = ({
	profiles,
	selectedProfileIds,
	onChange,
	label = '',
	id: idProp
}) => {
	const generatedId = useId();
	const controlId = idProp ?? generatedId;
	const containerRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);

	const allProfile = (profiles ?? []).find((item) => item.id === VIRTUAL_ALL_PROFILE_ID);
	const realProfiles = (profiles ?? []).filter((item) => item.id !== VIRTUAL_ALL_PROFILE_ID);
	const summaryLabel = getProfileMultiSelectLabel(selectedProfileIds, profiles);

	useEffect(() => {
		if (!isOpen) return undefined;

		const handlePointerDown = (event) => {
			if (!containerRef.current?.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handlePointerDown);
		return () => document.removeEventListener('mousedown', handlePointerDown);
	}, [isOpen]);

	const handleToggle = (profileId) => {
		onChange(toggleProfileInSelection(selectedProfileIds, profileId, profiles));
	};

	return (
		<div className={`profile-multi-select${isOpen ? ' profile-multi-select--open' : ''}`} ref={containerRef}>
			{label ? (
				<span className="profile-multi-select__label">{label}</span>
			) : null}
			<div className="profile-multi-select__control">
				<button
					type="button"
					id={controlId}
					className="profile-multi-select__trigger"
					aria-label={summaryLabel}
					aria-haspopup="listbox"
					aria-expanded={isOpen}
					onClick={() => setIsOpen((open) => !open)}
				>
					<span className="profile-multi-select__trigger-label">{summaryLabel}</span>
				</button>
				{isOpen && (
					<div className="profile-multi-select__menu" role="listbox" aria-multiselectable="true">
						{allProfile && (
							<label className="profile-multi-select__option profile-multi-select__option--all">
								<input
									type="checkbox"
									checked={isProfileSelectedInSelection(selectedProfileIds, VIRTUAL_ALL_PROFILE_ID, profiles)}
									onChange={() => handleToggle(VIRTUAL_ALL_PROFILE_ID)}
								/>
								<span>{allProfile.profileName}</span>
							</label>
						)}
						{realProfiles.map((profile) => (
							<label key={profile.id} className="profile-multi-select__option">
								<input
									type="checkbox"
									checked={isProfileSelectedInSelection(selectedProfileIds, profile.id, profiles)}
									onChange={() => handleToggle(profile.id)}
								/>
								<span>{profile.profileName}</span>
							</label>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

ProfileMultiSelect.propTypes = {
	profiles: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		profileName: PropTypes.string.isRequired
	})).isRequired,
	selectedProfileIds: PropTypes.arrayOf(PropTypes.string).isRequired,
	onChange: PropTypes.func.isRequired,
	label: PropTypes.string,
	id: PropTypes.string
};

export default ProfileMultiSelect;
